// extracted by mini-css-extract-plugin
module.exports = {"container":"post-list_container__3v3Gf"};